import "../styles/globals.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import  'rsuite/dist/rsuite.min.css'; 

import Layout from "./common/Layout";
import PathName from "../utilities/pathName";
import { wrapper, store } from "../store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRouter } from "next/router";
import { Provider } from "react-redux";
import { SessionProvider } from "next-auth/react"
import Script from "next/script";
import Router from 'next/router';
import NProgress from 'nprogress'; //nprogress module
import 'nprogress/nprogress.css'; //styles of nprogress
NProgress.configure({ easing: 'ease', speed: 200, showSpinner: false })
import { GoogleAnalytics } from "nextjs-google-analytics";

function MyApp({ Component, pageProps: { session, ...pageProps }, }) {
  const router = useRouter();
  const path = PathName();
Router.events.on('routeChangeStart', () => NProgress.start()); Router.events.on('routeChangeComplete', () => NProgress.done()); Router.events.on('routeChangeError', () => NProgress.done());  


  return (
    <>
     {/* <Script
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS|'G-9HTDCW6HW6'}`}
      />

      <Script id="google-analytics-script" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS|'G-9HTDCW6HW6'}', {
          page_path: window.location.pathname,
          });
    `}
      </Script> */}
<GoogleAnalytics trackPageViews />
     <SessionProvider session={session}>
      <Provider store={store}>
        <div className={path}>
          <Layout>
            <Component {...pageProps} key={router.asPath} />
          </Layout>
        </div>
      </Provider>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
      />
      </SessionProvider>
    </>
  );
}

export default MyApp;
